module.exports = __webpack_public_path__ + "static/fetch-ruffcut-blackmuzzle-56d02cc12754b163f71c9b160b825134.jpg";